import { render } from "./TestTalkingContext.vue?vue&type=template&id=c92cef82&scoped=true"
import script from "./TestTalkingContext.vue?vue&type=script&lang=js"
export * from "./TestTalkingContext.vue?vue&type=script&lang=js"

import "./TestTalkingContext.vue?vue&type=style&index=0&id=c92cef82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c92cef82"]])

export default __exports__